<ng-container *ngIf="showLoadMoreButton">
  <div class="nextpage" (click)="onButtonClicked()" *transloco="let t; read: 'shared'">
    {{t('loadMore')}}
  </div>
</ng-container>
